import { render, staticRenderFns } from "./DiagnosisText.vue?vue&type=template&id=373d07d2&scoped=true"
import script from "./DiagnosisText.vue?vue&type=script&lang=js"
export * from "./DiagnosisText.vue?vue&type=script&lang=js"
import style0 from "./DiagnosisText.vue?vue&type=style&index=0&id=373d07d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373d07d2",
  null
  
)

export default component.exports